<script setup lang="ts">
import { Alert, AlertDescription, AlertTitle } from './alert';
</script>

<template>
  <Alert variant="destructive">
    <AlertTitle>Page Not Found</AlertTitle>
    <AlertDescription>This page does not exist. The link you followed is broken or invalid.</AlertDescription>
  </Alert>
</template>
